import React from "react";
import Image from "components/image";
import Button from "components/button";
import RichText from "components/rich-text";
import ReviewsSnippet from "components/reviews-snippet";
import clsx from "clsx/lite";
import { Autoplay, Mousewheel } from "swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow-in-white.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow-in-white.svg";
import { Swiper, SwiperSlide } from "swiper/react";

const SlideItem = ({ slide, leftAlignContent }) => {
	const { image, mobileImage, cta, content } = slide;

	return (
		<div className="relative w-full">
			<div
				className={clsx(
					"w-4/5 z-10 absolute inset-0 h-3/5 lg:h-full mt-8 lg:mt-0 mx-auto",
					"md:w-1/2 md:flex md:flex-col md:justify-center md:items-center",
					leftAlignContent
						? "text-left md:items-start left-0 md:ml-16"
						: "text-center"
				)}
			>
				<div className="h-full lg:h-auto lg:w-8/12 mx-auto">
					{content && <RichText value={content} className={leftAlignContent ? "!text-left !mx-0" : ""} />}
					{cta && <Button data={{ ...cta, center: !leftAlignContent && cta.center }} className="mt-4" />}
					{(content || cta) && <ReviewsSnippet />}
				</div>
			</div>
			{mobileImage && (
				<Image
					image={mobileImage}
					alt={mobileImage?.alt}
					className="md:!hidden -z-10"
					to={mobileImage?.url}
				/>
			)}
			{image && (
				<Image
					image={image}
					alt={image?.alt}
					className="!hidden -z-10 md:!block"
					to={image?.url}
				/>
			)}
		</div>
	);
};

const SwipeableHeader = ({ data }) => {
	if (!data?.slides) return null;

	const settings = {
		modules: [Mousewheel, Autoplay],
		slidesPerView: 1,
		initialSlide: 0,
		preventClicks: true,
		autoplay: {
			delay: 8000,
			disableOnInteraction: false,
		},
		pagination: {
			clickable: true,
			el: ".swipeable-header-nav",
			type: "bullets",
		},
		navigation: {
			enabled: true,
			nextEl: ".s-h-next",
			prevEl: ".s-h-prev",
		},
		preventClicksPropagation: false,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
	};

	return (
		<div className="relative mb-10">
			<div className="flex justify-between">
				<Swiper {...settings}>
					{data.slides.map((slide, index) =>
						<SwiperSlide key={index}>
							<SlideItem key={index} slide={slide} leftAlignContent={data.leftAlignContent} />
						</SwiperSlide>
					)}
				</Swiper>
			</div>
			<div className="swipeable-header-nav" />
			<div className="absolute !bottom-16 !right-16 hidden md:flex">
				<button className="s-h-prev">
					<LeftArrow />
				</button>
				<button className="s-h-next">
					<RightArrow />
				</button>
			</div>
		</div>
	);
};

export default SwipeableHeader;